<template>
  <div class="product-block">

    <!-- Tab header line -->
    <div class="product-block-tab" @click="toggleDropdown">
      <slot name="title"></slot>
      <div class="product-block-tab-image" :class="{ 'is-active': isTabActive }"></div>
    </div>
    <!---->

    <!-- Tab dropdown -->
    <div class="product-block-dropdown" :class="{ 'is-active': isTabActive }" :style="{ 'max-height': `${dropdownHeight}px` }">
      <slot name="content"></slot>
    </div>
    <!---->

  </div>
</template>

<script>
export default {
  name: 'ProductTab',
  props: {
    height: {
      type: Number
    }
  },
  data () {
    return {
      isTabActive: true,
      dropdownHeight: 0,
      maxDropdownHeight: 186 // 6 (ingredients values) * 28px (<td> height) + 3px (<table> gap height) * 5 (ingredients values - 1)
    }
  },
  mounted () {
    this.dropdownHeight = this.height ? this.height : this.maxDropdownHeight
  },
  watch: {
    '$route.path': {
      handler: function () {
        this.isTabActive = true
        this.dropdownHeight = this.isTabActive ? this.height ? this.height : this.maxDropdownHeight : 0
      }
    }
  },
  methods: {
    toggleDropdown () {
      this.isTabActive = !this.isTabActive
      this.dropdownHeight = this.isTabActive ? this.height ? this.height : this.maxDropdownHeight : 0
    }
  }
}
</script>

<style lang="scss" scoped>
.product-block {
  width: calc(100% / 2 - 5px);

  display: flex;
  flex-direction: column;

  @media only screen and (max-width: 576px) {
    width: 100%;
  }

  & + & {
    margin-left: 20px;

    @media only screen and (max-width: 576px) {
      margin-left: 0;
    }
  }

  &-tab {
    padding: 0 10px;

    display: flex;
    align-items: center;
    justify-content: space-between;

    border-radius: 5px;

    &:hover {
      cursor: pointer;
      background: rgba(#000, .01);
    }

    &-image {
      width: 24px;
      height: 14px;

      background-image: url('../../../../../assets/shop/arrow.svg');
      background-position: center;
      background-size: 24px 14px;
      background-repeat: no-repeat;

      transform: rotate(180deg);
      transition: .2s;

      &.is-active {
        transform: rotate(0deg);
      }
    }
  }

  &-dropdown {
    overflow: hidden;
    transition: .2s;

    &.is-active {
      max-height: 0;
    }
  }
}
</style>
